addEventListener("DOMContentLoaded", (event) => {

  var geoSpecificBadge = document.querySelectorAll(".geo-specific-badge");
  geoSpecificBadge.forEach((geoBadge) => {
    geoBadge.style.display = "none";
  })

  var geoSpecificAnnouncementBar = document.querySelectorAll(".geo-specific-announcement-bar");
  geoSpecificAnnouncementBar.forEach((geoAnnouncementBar) => {
    geoAnnouncementBar.style.display = "none";
  })

  var geoSpecificBlocks = document.querySelectorAll(".geo-specific-block");
  geoSpecificBlocks.forEach((geoBlock) => {
    geoBlock.style.display = "none";
  })

  var announementSelectedCountry = ["AU", "US", "CA", "GB"];

  // function to get the user's location
  getUserCountry();

  function getUserCountry() {

    fetch('https://api.country.is/', {
      method: 'GET'
    })
      .then(response => response.json())
      .then(response => {
        isCountry = true;
        country_code = response.country;
        if (isCountry) {

          // product badge
          document.querySelectorAll('.geo-specific-badge[data-country="' + country_code + '"]').forEach((geoBadgeActive) => {
            geoBadgeActive.style.display = "block";
          })
          // product badge

          if(country_code == "AU"){
            document.querySelectorAll('[href="/products/ppl2"]').forEach((ppl_link)=>{
              ppl_link.style.display = 'none';
            })
          }

          // announcement bar
          if (announementSelectedCountry.indexOf(country_code) != -1) {
            announementSelectedCountry.forEach((selected_country) => {
              if (selected_country == country_code) {
                document.querySelectorAll('.geo-specific-announcement-bar[data-country="' + country_code + '"]').forEach((geoAnnounementActive) => {
                  geoAnnounementActive.style.display = "block";
                })
              }
            })
          } else {
            if (document.querySelectorAll('.geo-specific-announcement-bar[data-country="global"]')) {
              document.querySelectorAll('.geo-specific-announcement-bar[data-country="global"]').forEach((geoAnnounementActive) => {
                geoAnnounementActive.style.display = "block";
              })
            }
          }

          // announcement bar

          // geo block
          if (announementSelectedCountry.indexOf(country_code) != -1) {
            announementSelectedCountry.forEach((selected_country) => {
              if (selected_country == country_code) {
                document.querySelectorAll('.geo-specific-block[data-country="' + country_code + '"]').forEach((geoBlock) => {
                  geoBlock.style.display = "block";
                })
              }
            })
          } else {
            if (document.querySelectorAll('.geo-specific-block[data-country="global"]')) {
              document.querySelectorAll('.geo-specific-block[data-country="global"]').forEach((geoBlock) => {
                geoBlock.style.display = "block";
              })
            }
          }

          // geo block
        }
      })
      .catch(error => {
        console.error('Error: ' + error);
      })

  }

});